module.exports = __webpack_public_path__ + "static/media/Asset 14.2@3x.0882c8d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 14.2@3x.png
// module id = 2419
// module chunks = 0